'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import Slideline from '../components/Slideline';

let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--works'
        // Fns
        if(Env.mobileCSS === false && this.view.querySelector('.jsSlideline--view')) {
            this.slideshow = new Slideline(this.view.querySelector('.jsSlideline--view'))
            this.slideshow.setup()
        }
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        if(typeof this.slideshow != "undefined") {
            this.slideshow.destroy()
        }
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
        }, 200);
    }

    intro()
    {
        const tl = new TimelineLite()
        const $itemsBg = this.view.querySelectorAll('.jsItem .bg')
        const $itemsInner = this.view.querySelectorAll('.jsItem .inner')
        const $prev = this.view.querySelector('.jsPrevious .text')
        const $next = this.view.querySelector('.jsNext .text')
        if(Env.mobileCSS == true) {
            tl.add([
                TweenMax.staggerFromTo($itemsBg , 1 , { opacity : 0 , y : "0%" } , { opacity : 1, ease : Power4.easeOut },.1),
                TweenMax.fromTo($itemsInner , 1 , { opacity : 0 } , { opacity : 1  , ease : Power4.easeOut }),
            ])
        } else {
            tl.add([
                TweenMax.staggerFromTo($itemsBg , 1 , { opacity : 0 } , { opacity : 1 , y : '0%' , ease : Power4.easeOut },.05),
                TweenMax.staggerFromTo($itemsInner , .8 , { opacity : 0 , y : 50 } , { opacity : 1 , y : 0  , ease : Power4.easeOut , delay : .49 },.05),
                TweenLite.fromTo($prev , .5 , { autoAlpha : 0 , x : -20 } , { autoAlpha : 1 , x : 0 , ease : Cubic.easeOut , delay : .4 }),
                TweenLite.fromTo($next , .5 , { autoAlpha : 0 , x : 20 } , { autoAlpha : 1 , x : 0 , ease : Cubic.easeOut , delay : .4 }),
            ])
            tl.add(()=>{
                if(this.view.querySelector('.jsSlideline--view') != null) {
                    this.view.querySelector('.jsSlideline--view').classList.add('is--ready')
                }
                TweenLite.set($itemsBg , { clearProps : "x,opacity" })
                TweenLite.set($itemsInner , { clearProps : "all" })
            })
        }

    }
}

page = Barba.BaseView.extend({
    namespace: 'works',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;


// WEBPACK FOOTER //
// ./resources/js/view/works.js